export const primaryColor = '#b6c416';
export const secondaryColor = '#fa571d'
export const backgroundColor = '#282828';
